import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["dataTestComponent", "dataTestId"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { forwardRef } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import ReactPropTypes from 'prop-types';
import { describe, PropTypes } from '@amzn/stencil-react-desc';
import { isDocumentedComponent } from "../../types/DocumentedComponent";
import { jsx as ___EmotionJSX } from "@emotion/core";
export var dataTestKeys = ['data-test-component', 'data-test-id'];
export var buildDataTestProps = function buildDataTestProps(_ref) {
  var dataTestComponent = _ref.dataTestComponent,
      dataTestId = _ref.dataTestId;
  var testComponentProp = !!dataTestComponent ? {
    'data-test-component': dataTestComponent
  } : {};
  var testIdProp = !!dataTestId ? {
    'data-test-id': dataTestId
  } : {};
  return _objectSpread(_objectSpread({}, testComponentProp), testIdProp);
};
export var withTestAttributes = function withTestAttributes(_ref2) {
  var component = _ref2.component,
      id = _ref2.id;
  return function (WrappedComponent) {
    var ComponentWithTestAttributes = /*#__PURE__*/forwardRef(function (_ref3, ref) {
      var _ref3$dataTestCompone = _ref3.dataTestComponent,
          dataTestComponent = _ref3$dataTestCompone === void 0 ? component : _ref3$dataTestCompone,
          _ref3$dataTestId = _ref3.dataTestId,
          dataTestId = _ref3$dataTestId === void 0 ? id : _ref3$dataTestId,
          props = _objectWithoutProperties(_ref3, _excluded);

      var dataTestProps = buildDataTestProps({
        dataTestComponent: dataTestComponent,
        dataTestId: dataTestId
      });
      return ___EmotionJSX(WrappedComponent, _extends({}, dataTestProps, props, {
        ref: ref
      }));
    });
    var HoistedComponent = hoistNonReactStatics(ComponentWithTestAttributes, WrappedComponent);
    var displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    ComponentWithTestAttributes.displayName = "withTestAttributes(".concat(displayName, ")");
    var description = isDocumentedComponent(WrappedComponent) ? WrappedComponent.documentation.toJSON().description : '';
    var DocumentedComponentWithTestAttributes = describe(HoistedComponent).description(description);

    if (isDocumentedComponent(WrappedComponent)) {
      DocumentedComponentWithTestAttributes.propTypes = _objectSpread(_objectSpread({}, WrappedComponent.describedPropTypes), {}, {
        dataTestId: PropTypes.string.description("Sets the 'data-test-id' attribute in the DOM, for testing purposes.")
      });
    } else if (WrappedComponent.propTypes) {
      HoistedComponent.propTypes = _objectSpread(_objectSpread({}, WrappedComponent.propTypes), {}, {
        dataTestId: ReactPropTypes.string
      });
    }

    if (WrappedComponent.defaultProps) {
      HoistedComponent.defaultProps = _objectSpread({}, WrappedComponent.defaultProps);
    }

    var _ref4 = WrappedComponent,
        withComponent = _ref4.withComponent;

    if (withComponent !== undefined) {
      HoistedComponent.withComponent = function (tag) {
        return withTestAttributes({
          component: component,
          id: id
        })(withComponent(tag));
      };
    }

    return DocumentedComponentWithTestAttributes;
  };
};